import { useMutation } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';

interface SendPaymentInitiationWhatsappParams {
  plan_type: 'personal' | 'group' | 'webinar';
  duration_months: number;
  amount: number;
  currency?: string;
}

interface SendPaymentInitiationWhatsappResponse {
  success: boolean;
  message?: string;
}

export default function useSendRenewalPaymentInitiationWhatsapp(
  handleOnSuccess?: (data: SendPaymentInitiationWhatsappResponse) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<
    SendPaymentInitiationWhatsappResponse,
    Error,
    SendPaymentInitiationWhatsappParams
  >(
    async params => {
      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await ChessRestClient.post<SendPaymentInitiationWhatsappResponse>(
        'subscription/v1/send-renewal-payment-initiation-whatsapp/',
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}

